import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import fund from './modules/fund'
import stock from './modules/stock'
import indice from './modules/indice'
import article from './modules/article'
import global from './modules/global'
import watchlist from './modules/watchlist'
import gold from './modules/gold'
import onboarding from './modules/onboarding'
import pdpa from './modules/pdpa'

Vue.use(Vuex)

const createStore = new Vuex.Store({
    modules: {
      auth,
      fund,
      stock,
      indice,
      article,
      global,
      watchlist,
      gold,
      onboarding,
      pdpa
    }
  })


export default createStore
